import { useDispatch, useSelector } from "react-redux";
import usePageTracking from "../../../hooks/usePageTracking";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";
import { Button, Card, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { createOrder } from "../../../redux/slices/shopSlice";
import "./checkout.scss";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

const Checkout = () => {
  const dispatch = useDispatch();

  // Track Activity
  usePageTracking("CHECKOUT");
  useEffect(() => {
    dispatch(activityStart({ page_name: "CHECKOUT", platform: "web" }));
    return () => dispatch(activityEnd({ page_name: "CHECKOUT" }));
  }, [dispatch]);
  const [loading, setLoading] = useState(false);
  const store = useSelector((state) => state.auth?.user);
  const [errors, setErrors] = useState({});
  console.log(store, "store");
  const { cartItems } = useSelector((state) => state.shop);
  const navigate = useNavigate();

  const [billing, setBilling] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    postcode: "",
    country: "US",
  });
  const [sameAsBilling, setSameAsBilling] = useState(true);

  const [shipping, setShipping] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    postcode: "",
    country: "US",
  });
  const validateForm = () => {
    const newErrors = {};

    /* ---------------- BILLING VALIDATION ---------------- */

    if (!billing.first_name.trim())
      newErrors.first_name = "First name is required";

    if (!billing.last_name.trim())
      newErrors.last_name = "Last name is required";

    if (!billing.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(billing.email)) {
      newErrors.email = "Enter a valid email";
    }

    if (!billing.phone.trim()) newErrors.phone = "Phone number is required";

    if (!billing.address_1.trim())
      newErrors.address_1 = "Street address is required";

    if (!billing.city.trim()) newErrors.city = "City is required";

    if (!billing.state.trim()) newErrors.state = "State is required";

    if (!billing.postcode.trim()) newErrors.postcode = "Zip code is required";
    if (!billing.country.trim()) newErrors.country = "Country code is required";

    /* ---------------- SHIPPING VALIDATION ---------------- */

    if (!sameAsBilling) {
      if (!shipping.first_name.trim())
        newErrors.shipping_first_name = "Shipping first name is required";

      if (!shipping.last_name.trim())
        newErrors.shipping_last_name = "Shipping last name is required";

      if (!shipping.email.trim()) {
        newErrors.shipping_email = "Shipping email is required";
      } else if (!/\S+@\S+\.\S+/.test(shipping.email)) {
        newErrors.shipping_email = "Enter a valid shipping email";
      }

      if (!shipping.phone.trim())
        newErrors.shipping_phone = "Shipping phone is required";

      if (!shipping.address_1.trim())
        newErrors.shipping_address_1 = "Shipping address is required";

      if (!shipping.city.trim())
        newErrors.shipping_city = "Shipping city is required";

      if (!shipping.state.trim())
        newErrors.shipping_state = "Shipping state is required";

      if (!shipping.postcode.trim())
        newErrors.shipping_postcode = "Shipping zip code is required";
      if (!shipping.country.trim())
        newErrors.shipping_country = "Shipping country code is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const subtotal = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0,
  );

  // const handleChange = (e) => {
  //   setBilling({
  //     ...billing,
  //     [e.target.name]: e.target.value,
  //   });

  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setBilling((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleShippingChange = (e) => {
    const { name, value } = e.target;

    setShipping((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [`shipping_${name}`]: "",
    }));
  };
  const handlePlaceOrder = async () => {
    if (!validateForm()) return;
    const lineItems = cartItems.map((item) => ({
      product_id: item.id,
      quantity: item.quantity,
    }));
    const finalShipping = sameAsBilling ? billing : shipping;
    const orderPayload = {
      payment_method: "stripe",
      payment_method_title: "Credit Card (Stripe)",
      set_paid: false,

      billing: {
        first_name: billing.first_name,
        last_name: billing.last_name,
        email: billing.email,
        phone: billing.phone,
        address_1: billing.address_1,
        address_2: billing.address_2,
        city: billing.city,
        state: billing.state,
        postcode: billing.postcode,
        country: billing.country,
      },

      shipping: {
        first_name: finalShipping.first_name,
        last_name: finalShipping.last_name,
        email: finalShipping.email,
        phone: finalShipping.phone,
        address_1: finalShipping.address_1,
        address_2: finalShipping.address_2,
        city: finalShipping.city,
        state: finalShipping.state,
        postcode: finalShipping.postcode,
        country: finalShipping.country,
      },

      line_items: lineItems,
    };

    try {
      setLoading(true);
      const response = await dispatch(createOrder(orderPayload)).unwrap();

      console.log("Order Created:", response);

      if (response.payment_url) {
        window.location.href = response.payment_url;
      }
    } catch (error) {
      console.error("Order creation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (store) {
      setBilling((prev) => ({
        ...prev,
        first_name: store.first_name || "",
        last_name: store.last_name || "",
        email: store.email || "",
        phone: store.phone || "",
        city: store.city || "",
        state: store.living_state || "",
      }));
    }
  }, [store]);
  useEffect(() => {
    if (sameAsBilling) {
      setShipping({
        ...billing,
        country: billing.country || "US",
      });
    }
  }, [sameAsBilling, billing]);
  return (
    <div className="checkout-wrapper">
      {/* <div className="page-title-heading d-flex align-items-center">
        <FiArrowLeft
          size={40}
          className="icon cursor-pointer"
          onClick={() => navigate("/shop/products")}
        />
        <h3 className="page-title">Checkout</h3>
      </div> */}

      <div className="app-page-title">
        <div className="page-title-heading d-flex align-items-center">
          <FiArrowLeft
            size={40}
            className="icon cursor-pointer"
            onClick={() => navigate("/shop/products")}
          />
          <h3 className="page-title">Checkout</h3>
        </div>
      </div>

      <div className="checkout-layout">
        {/* LEFT SIDE FORM */}

        <div className="left-card">
          <Card className="checkout-form">
            <Card.Body>
              <h6 className="pb-0">Billing Details</h6>

              <div className="form-grid g-3 row">
                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">First Name</Form.Label>
                    <Form.Control
                      name="first_name"
                      value={billing.first_name}
                      onChange={handleChange}
                      className="col-input"
                    />
                    {errors.first_name && (
                      <div className="invalid-feedback">
                        {errors.first_name}
                      </div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">Last Name</Form.Label>
                    <Form.Control
                      name="last_name"
                      value={billing.last_name}
                      onChange={handleChange}
                      className="col-input"
                    />
                    {errors.last_name && (
                      <div className="invalid-feedback">{errors.last_name}</div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">Email</Form.Label>
                    <Form.Control
                      name="email"
                      type="email"
                      value={billing.email}
                      onChange={handleChange}
                      className="col-input"
                    />
                    {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">Phone</Form.Label>
                    <Form.Control
                      name="phone"
                      value={billing.phone}
                      onChange={handleChange}
                      className="col-input"
                    />
                    {errors.phone && (
                      <div className="invalid-feedback">{errors.phone}</div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">
                      Street Address
                    </Form.Label>
                    <Form.Control
                      name="address_1"
                      value={billing.address_1}
                      onChange={handleChange}
                      className="col-input"
                    />
                    {errors.address_1 && (
                      <div className="invalid-feedback">{errors.address_1}</div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0 ">
                    <Form.Label className="col-label">
                      Apartment, Suite, etc.(optional){" "}
                    </Form.Label>
                    <Form.Control
                      name="address_2"
                      value={billing.address_2}
                      onChange={handleChange}
                      className="col-input"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">City</Form.Label>
                    <Form.Control
                      name="city"
                      value={billing.city}
                      onChange={handleChange}
                      className="col-input"
                    />
                    {errors.city && (
                      <div className="invalid-feedback">{errors.city}</div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">State</Form.Label>
                    <Form.Control
                      name="state"
                      value={billing.state}
                      onChange={handleChange}
                      className="col-input"
                    />
                    {errors.state && (
                      <div className="invalid-feedback">{errors.state}</div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">Zip Code</Form.Label>
                    <Form.Control
                      name="postcode"
                      value={billing.postcode}
                      onChange={handleChange}
                      className="col-input"
                    />
                    {errors.postcode && (
                      <div className="invalid-feedback">{errors.postcode}</div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group mb-0">
                    <Form.Label className="col-label">Country</Form.Label>
                    <Form.Control
                      name="country"
                      value={billing.country || "US"}
                      onChange={handleChange}
                      className={`col-input ${
                        errors.country ? "is-invalid" : ""
                      }`}
                    />
                    {errors.country && (
                      <div className="invalid-feedback d-block">
                        {errors.country}
                      </div>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="shipping-header mt-4">
                <h6>Shipping Address</h6>

                <Form.Check
                  type="checkbox"
                  label="Same as billing"
                  checked={sameAsBilling}
                  onChange={(e) => setSameAsBilling(e.target.checked)}
                />
              </div>

              {!sameAsBilling && (
                <div className="form-grid g-3 row">
                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">First Name</Form.Label>
                      <Form.Control
                        name="first_name"
                        value={shipping.first_name}
                        onChange={handleShippingChange}
                        // className="col-input"
                        className={`col-input ${
                          errors.shipping_first_name ? "is-invalid" : ""
                        }`}
                      />
                      {errors.shipping_first_name && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_first_name}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">Last Name</Form.Label>

                      <Form.Control
                        name="last_name"
                        value={shipping.last_name}
                        onChange={handleShippingChange}
                        className={`col-input ${
                          errors.shipping_last_name ? "is-invalid" : ""
                        }`}
                      />

                      {errors.shipping_last_name && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_last_name}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">Email</Form.Label>
                      <Form.Control
                        name="email"
                        type="email"
                        value={shipping.email}
                        onChange={handleShippingChange}
                        className={`col-input ${
                          errors.shipping_email ? "is-invalid" : ""
                        }`}
                      />
                      {errors.shipping_email && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_email}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">Phone</Form.Label>
                      <Form.Control
                        name="phone"
                        value={shipping.phone}
                        onChange={handleShippingChange}
                        className={`col-input ${
                          errors.shipping_phone ? "is-invalid" : ""
                        }`}
                      />
                      {errors.shipping_phone && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_phone}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Street Address
                      </Form.Label>
                      <Form.Control
                        name="address_1"
                        value={shipping.address_1}
                        onChange={handleShippingChange}
                        className={`col-input ${
                          errors.shipping_address_1 ? "is-invalid" : ""
                        }`}
                      />
                      {errors.shipping_address_1 && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_address_1}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0 ">
                      <Form.Label className="col-label">
                        Apartment, Suite, etc.(optional){" "}
                      </Form.Label>
                      <Form.Control
                        name="address_2"
                        value={shipping.address_2}
                        onChange={handleShippingChange}
                        className="col-input"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">City</Form.Label>
                      <Form.Control
                        name="city"
                        value={shipping.city}
                        onChange={handleShippingChange}
                        className={`col-input ${
                          errors.shipping_city ? "is-invalid" : ""
                        }`}
                      />
                      {errors.shipping_city && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_city}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">State</Form.Label>
                      <Form.Control
                        name="state"
                        value={shipping.state}
                        onChange={handleShippingChange}
                        className={`col-input ${
                          errors.shipping_state ? "is-invalid" : ""
                        }`}
                      />
                      {errors.shipping_state && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_state}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">Zip Code</Form.Label>
                      <Form.Control
                        name="postcode"
                        value={shipping.postcode}
                        onChange={handleShippingChange}
                        className={`col-input ${
                          errors.shipping_postcode ? "is-invalid" : ""
                        }`}
                      />
                      {errors.shipping_postcode && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_postcode}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">Country</Form.Label>
                      <Form.Control
                        name="country"
                        value={shipping.country || "US"}
                        onChange={handleShippingChange}
                        className={`col-input ${
                          errors.shipping_country ? "is-invalid" : ""
                        }`}
                      />
                      {errors.shipping_country && (
                        <div className="invalid-feedback d-block">
                          {errors.shipping_country}
                        </div>
                      )}
                    </Form.Group>
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>

        <div className="right-card">
          {/* RIGHT SIDE ORDER SUMMARY */}

          <Card className="order-summary">
            <Card.Body>
              <h6>Your Order</h6>

              {cartItems.map((item) => (
                // order-items
                <div key={item.id} className="summary-row">
                  <span>
                    {item.name} × {item.quantity}
                  </span>

                  <span>${(item.price * item.quantity).toFixed(2)}</span>
                </div>
              ))}

              {/* <hr /> */}

              <div className="summary-row">
                <span>Subtotal</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>

              <div className="summary-row">
                <span>Shipping</span>
                <span>Free</span>
              </div>

              <div className="summary-row total">
                <span>Total</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>
            </Card.Body>
          </Card>

          {/* PAYMENT SECTION */}
          <Card>
            <Card.Body>
              <div className="payment-section">
                <h6 className="payment-title">Payment</h6>

                <div className="payment-card">
                  <div className="card-icons">
                    <span className="card-badge">VISA</span>
                    <span className="card-badge">MC</span>
                    <span className="card-badge">AMEX</span>
                  </div>

                  <p className="payment-text">
                    You will be redirected to a secure payment page to complete
                    your purchase with Stripe.
                  </p>

                  <div className="secure-text">
                    ✓ Secure payment powered by Stripe
                  </div>
                </div>
              </div>

              <Button
                className="place-order-btn"
                onClick={handlePlaceOrder}
                disabled={loading}
              >
                {loading ? "Redirecting..." : "Place Order"}
              </Button>
            </Card.Body>
          </Card>
        </div>

        {/* SHIPPING SECTION */}
        {/* <Card className="checkout-form mt-4">
            <Card.Body></Card.Body>
          </Card> */}
      </div>
    </div>
  );
};

export default Checkout;
